import { Checkbox, Label } from "@workspace/frontend-ui";
import { forwardRef } from "react";

type FieldChangeEvent = {
  target: { name?: string; checked: boolean; value: boolean };
};

type Props = {
  checked?: boolean;
  disabled?: boolean;
  label?: string;
  name?: string;
  onClick?: () => void;
  onChange?: (event: FieldChangeEvent) => void;
  onBlur?: (event: FieldChangeEvent) => void;
};

const CustomCheckbox = forwardRef<HTMLButtonElement, Props>(
  ({ checked, disabled, label, name, onBlur, onChange, onClick }, ref) => {
    const handleCheckedChange = (nextChecked: boolean | "indeterminate") => {
      const isChecked = nextChecked === true;
      onClick?.();
      onChange?.({ target: { name, checked: isChecked, value: isChecked } });
    };

    const handleBlur = () => {
      const isChecked = Boolean(checked);
      onBlur?.({ target: { name, checked: isChecked, value: isChecked } });
    };

    const checkbox = (
      <Checkbox
        ref={ref}
        checked={checked}
        disabled={disabled}
        name={name}
        onBlur={handleBlur}
        onCheckedChange={handleCheckedChange}
        className="m-1 border-muted-foreground"
      />
    );

    if (!label) {
      return (
        <div className="flex items-center justify-between">{checkbox}</div>
      );
    }

    return (
      <Label className="text-xs font-normal">
        {checkbox}
        {label}
      </Label>
    );
  },
);

export default CustomCheckbox;
